import LandingPage from '../templates/LandingPage';
import lighting from '../../assets/svg/lighting.svg'
import Button from '../components/common/Button';
import { useEffect, useState } from 'react';
import { convert } from '../../services/widget';

function Calculator() {

  const [amount, setAmount] = useState(0)
  const [sell, setSell] = useState(false)
  const [rate, setRate] = useState({})

  const m = JSON.parse(window.localStorage.getItem("bMerchant"))

  useEffect(() => {
    convert("USD", "BTC").then( res => {
      setRate( res )
    }).catch(err=>console.log(err))
  }, [])

  return (
    <LandingPage sell={sell}>
      <div className="px-8 lg:px-16 py-18 flex flex-col items-center h-screen section-one">
        <div className="flex flex-col w-full lg:w-1/3 mt-32 justify-between">
          <p className="text-yellow text-3xl font-bold">
            Calculate your exchange
          </p>
          <div className="flex opacity-50 text-white items-start">
            It only take a second to calculate any amount of bitcoin to naira before you sell
          </div>
        </div>
        <div className="flex flex-col w-full lg:w-1/3 overflow-y-scroll mb-12">

          <span className="text-white text-lg mt-4 font-bold">If you sell</span>
          <div className="py-8 px-5 lg:px-10 rounded-lg my-4 text-white bg-brown bg-opacity-25">
            <h1 className="font-bold text-xl flex items-center">
              USD  <input type="number" className="bg-transparent outline-none w-1/2 ml-2" value={amount} focus onChange={ e => setAmount(e.target.value) } />

              <span className="flex">BTC { (amount * (rate["BTC"] || 0)).toFixed(2) }</span>
            </h1>
          </div>
          <span className="text-white text-lg font-bold">You will get</span>
          <div className="py-8 px-5 lg:px-10 rounded-lg my-4 text-white bg-brown bg-opacity-25 text-xl">
            <h1 className="font-bold">NGN { (amount * m.buying_at).toFixed(2) } </h1>
          </div>

          <Button onClick={ () => setSell( !sell ) } className="text-brown-dark border-0 bg-yellow flex items-center justify-center m-4 font-bold m-4 text-sm px-12 py-5 rounded-sm ">
            <img src={lighting} alt="z" width="10px"/> &nbsp; Proceed to sell
          </Button>
        </div>
      </div>
    </LandingPage>
  );
}

export default Calculator;
